import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CurrentUser } from '../model/user.model';
import { UserAuthService } from '../service/user-auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  showPrint = true;

  loginUser: CurrentUser | null = null;
  emailChangeForm: FormGroup;
  emailChangeModalRef?: BsModalRef;
  isSubmittingEmailChange = false;
  emailChangeSuccessMessage = '';
  emailChangeErrorMessage = '';

  get userName(): string {
    if (!this.loginUser) return '';

    return `${this.loginUser.firstname} ${this.loginUser.lastname}`;
  }

  get isAuthenticated(): boolean {
    return !!this.loginUser;
  }

  get isStudent(): boolean {
    return !!this.loginUser && this.loginUser.role === 0;
  }

  constructor(
    private __userAuthService: UserAuthService,
    private __modalService: BsModalService,
    private __formBuilder: FormBuilder
  ) {
    this.emailChangeForm = this.__formBuilder.group({
      newEmail: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {
    this.__userAuthService.currentUser.subscribe(user => {
      this.loginUser = user;
    });
  }

  logout(): void {
    this.__userAuthService.logout();
  }

  openChangeEmailModal(template: TemplateRef<unknown>): void {
    this.emailChangeForm.reset();
    this.emailChangeSuccessMessage = '';
    this.emailChangeErrorMessage = '';
    this.isSubmittingEmailChange = false;
    this.emailChangeModalRef = this.__modalService.show(template, {
      keyboard: true,
      ignoreBackdropClick: false,
    });
  }

  requestEmailChange(): void {
    this.emailChangeSuccessMessage = '';
    this.emailChangeErrorMessage = '';

    if (this.emailChangeForm.invalid) {
      this.emailChangeForm.markAllAsTouched();
      return;
    }

    const newEmail = (this.emailChangeForm.value.newEmail || '').trim();
    this.isSubmittingEmailChange = true;

    this.__userAuthService.requestEmailChange(newEmail).subscribe({
      next: () => {
        this.isSubmittingEmailChange = false;
        this.emailChangeForm.reset();
        this.emailChangeSuccessMessage = 'Verification email sent. Please check your new email address.';
      },
      error: err => {
        this.isSubmittingEmailChange = false;
        this.emailChangeErrorMessage = err && err.message ? err.message : 'Unable to request email change. Please try again.';
      }
    });
  }
}
